import { transcribe } from "@/utils/assistant";
import { useMutation } from "@tanstack/react-query";

export default function useSendTranscribe() {
  const { mutateAsync: transcribeAudio, isPending: isTranscribing } = useMutation({
    mutationFn: transcribe,
  });

  return { transcribeAudio, isTranscribing };
}
